import * as Yup from 'yup';

import { CarePlanType } from '~clients/models';

import { CARE_PLAN_TYPES } from '~clients/config/carePlanTypes';

import { endDateNotBeforeStart } from '~clients/forms/care-plans/dateRange';

// Create-care-plan form config. Package options are per-client, built in CarePlanFormModal.
export const carePlanTypeOptions: Array<{ id: CarePlanType; name: string }> = (
  Object.keys(CARE_PLAN_TYPES) as CarePlanType[]
).map((planType) => ({ id: planType, name: CARE_PLAN_TYPES[planType].label }));

export const carePlanFormSchema = Yup.object().shape({
  plan_type: Yup.string().required('Plan type is required'),
  package_id: Yup.mixed().test(
    'required',
    'Package is required',
    (value) => value !== undefined && value !== null && value !== '',
  ),
  end_date: endDateNotBeforeStart,
});
